var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"local-preloader"},[_c('div',{staticClass:"status"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle1"}),_c('div',{staticClass:"circle2"}),_c('div',{staticClass:"circle3"})])])])
}]

export { render, staticRenderFns }